"use client";
const VALID_EMAIL = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const VALID_NAME = new RegExp("^(?<firstchar>(?=\\p{Script=Latin}))((?<alphachars>\\p{Script=Latin})|(?<specialchars>\\p{Script=Latin}['-](?=\\p{Script=Latin}))|(?<spaces> (?=\\p{Script=Latin})))*\\s*$", "u");
const VALID_ADDRESS = /^[^%$()?;,:+&|¤#£"@!*¨^~`]*$/;
const VALID_FIRST_CELL_PHONE_DIGIT = /^[4,9]/;
const VALID_DIGITS = /^[0-9]+$/;
const REG_NO_FULL_PATTERN = /^[A-Z]{2}[1-9][0-9]{4}$/;
const REG_NO_FULL_LENGTH = 7;
const WHITE_SPACE = /\s/g;
export {
  REG_NO_FULL_LENGTH,
  REG_NO_FULL_PATTERN,
  VALID_ADDRESS,
  VALID_DIGITS,
  VALID_EMAIL,
  VALID_FIRST_CELL_PHONE_DIGIT,
  VALID_NAME,
  WHITE_SPACE
};
